import React, { useState } from 'react';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { moveToAnotherGatewayRequest, validateGatewayAssetRequest, clearValidateGatewayAssetState } from './actions';
import { GeneralInput } from 'sharedComponents/GeneralInput';
import PropTypes from 'prop-types';
import { IconCheckedFilled, IconError } from 'svgIcons/MotionPortalIcons';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import colors from 'theme/_colors.scss';
import './style.scss';
import { apiCallStatus } from 'helpers/constants';
import { MAX_SEARCH_LENGTH } from './constants';

const MoveToAnotherGatewayComponent = ({ show, close, asset, gatewayID, gatewaySerialNumber, isMoveValid, validationLoadingStatus, onResetAssetInfo }) => {
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();

    // Local state for inputs and validation
    const [serialNumber, setSerialNumber] = useState(gatewaySerialNumber || '');
    const [nodeId, setNodeId] = useState(asset?.nodeId || '');

    const handleValidate = async () => {
        dispatch(validateGatewayAssetRequest(asset?.serialNumber, serialNumber, nodeId));
    };

    const handleMove = () => {
        dispatch(moveToAnotherGatewayRequest(asset?.serialNumber, serialNumber, nodeId, gatewayID, onResetAssetInfo));
        close();
        dispatch(clearValidateGatewayAssetState());
    };
    const handleClose = () => {
        dispatch(clearValidateGatewayAssetState());
        close();
    };
    return (
        <GeneralDialog
            show={show}
            id='move-asset-dialog'
            close={handleClose}
            dialogClassName='move_asset_dialog'
            closeButton={true}
            title={<h1 className='move_asset_dialog__title'>
                <span className='move_asset_dialog__title-text'>
                    {translate('ABB.Powertrain.Frontend.MoveToAnotherGateway')}
                </span>
            </h1>}
            cancelButtonProps={{
                text: translate('ABB.Powertrain.Frontend.cancelLabel'),
            }}
            acceptButtonProps={{
                text: isMoveValid
                    ? translate('ABB.Powertrain.Frontend.MoveLabel')
                    : translate('ABB.Powertrain.Frontend.ValidateLabel'),
                onClick: isMoveValid ? handleMove : handleValidate,
                disabled: validationLoadingStatus === apiCallStatus.LOADING || !serialNumber || !nodeId,
            }}
            persistent={false}
        >
            <div className='move__asset__input-container'>
                {isMoveValid === true &&
                    <div className='move__asset__success-container'>
                        <IconCheckedFilled
                            width={18}
                            height={18}
                            color={colors.jungleGreen}
                            className='success-icon'
                        />
                        <span>{translate('ABB.Powertrain.Frontend.ValidationSuccess')}</span>
                    </div>
                }
                {isMoveValid === false &&
                    <div className='move__asset__error-container'>
                        <IconError
                            width={24}
                            height={24}
                            color={colors.pomegranate}
                            className='error-icon'
                        />
                        <span>{translate('ABB.Powertrain.Frontend.ValidationFailed', { serialNumber: serialNumber })}</span>
                    </div>
                }
                <LoadingStatusWrapper
                    loadingStatus={[validationLoadingStatus]}
                    transparent
                    useCustomAnchor>
                    <form>
                        <div id='move__asset__label'>
                            {translate('ABB.Powertrain.Frontend.TargetGatewaySerialNumber')}
                        </div>
                        <div className='move__asset__input-wrapper'>
                            <div className='move__asset__input-wrapper__inner'>
                                <GeneralInput
                                    className={`move__asset__input${isMoveValid === false ? ' move__asset__input--error' : ''}`}
                                    onChange={value => setSerialNumber(value)}
                                    value={serialNumber}
                                    maxLength={MAX_SEARCH_LENGTH}
                                />
                            </div>
                        </div>
                        <div id='move__asset__message'>
                            {translate('ABB.Powertrain.Frontend.CurrentGatewayFilledMessage')}
                        </div>
                        <div id='move__asset__label'>
                            {translate('ABB.Powertrain.Frontend.TargetNodeId')}
                        </div>
                        <div className='move__asset__input-wrapper'>
                            <div className='move__asset__input-wrapper__inner'>
                                <GeneralInput
                                    className={`move__asset__input${isMoveValid === false ? ' move__asset__input--error' : ''}`}
                                    onChange={value => setNodeId(value)}
                                    value={nodeId}
                                    maxLength={MAX_SEARCH_LENGTH}
                                />
                            </div>
                        </div>
                        <div id='move__asset__message'>
                            {translate('ABB.Powertrain.Frontend.CurrentNodeIdMessage')}
                        </div>
                    </form>
                </LoadingStatusWrapper>
            </div>
        </GeneralDialog>
    );
};
MoveToAnotherGatewayComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    gatewayID: PropTypes.any,
    gatewaySerialNumber: PropTypes.string,
    asset: PropTypes.object,
    onResetAssetInfo: PropTypes.func,
};
export default MoveToAnotherGatewayComponent;
